<template>
    <div class="training-step4">
        <el-tabs v-model="activeName" @tab-click="handleTabChange">
            <el-tab-pane label="报名管理" name="1"></el-tab-pane>
            <el-tab-pane label="学员管理" name="2"></el-tab-pane>
            <el-tab-pane label="考勤管理" name="3"></el-tab-pane>
            <el-tab-pane label="学习管理" name="4"></el-tab-pane>
            <!-- 20210310隐藏需求 -->
            <!-- <el-tab-pane label="通知" name="5"></el-tab-pane> -->
        </el-tabs>
        
        <div class="training-btn-tab" v-if="activeName === '4'">
            <div class="training-btn-tab-item" v-bind:class="{active: studyTab === 1}" @click="changeStudyTab(1)">活动情况</div>
            <div class="training-btn-tab-item" v-bind:class="{active: studyTab === 2}" @click="changeStudyTab(2)">学员情况</div>
        </div>

        <div class="training-step4-search-wrap" v-if="activeName === '1'">
            <el-form :inline="true" class="training-search-form">
                <el-form-item label="姓名：">
                    <el-input v-model="signUpSearchForm.userName"></el-input>
                </el-form-item>
                <el-form-item label="归属部门：">
                    <el-cascader
                        :options="orgList"
                        placeholder="请选择"
                        :props="{ checkStrictly: true, label: 'name', value: 'id', children: 'orgs' }"
                        v-model="signUpSearchForm.orgId"
                        clearable></el-cascader>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select v-model="signUpSearchForm.status" placeholder="请选择">
                        <el-option label="" value=""></el-option>
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="审核通过" :value="1"></el-option>
                        <el-option label="未通过" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" class="search-btn-item">
                    <el-button size="mini" @click="searchSignData">查询</el-button>
                    <el-button size="mini" class="reset-button" @click="resetSignData">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="training-step4-search-wrap" v-if="activeName === '2'">
            <el-form :inline="true" class="training-search-form">
                <el-form-item label="姓名：">
                    <el-input v-model="studentSearchForm.userName"></el-input>
                </el-form-item>
                <el-form-item label="归属部门：">
                    <el-cascader
                        :options="orgList"
                        placeholder="请选择"
                        :props="{ checkStrictly: true, label: 'name', value: 'id', children: 'orgs' }"
                        v-model="studentSearchForm.orgId"
                        clearable></el-cascader>
                </el-form-item>
                <el-form-item label="报到情况：">
                    <el-select v-model="studentSearchForm.status" placeholder="请选择">
                        <el-option label="" value=""></el-option>
                        <el-option label="未报到" :value="0"></el-option>
                        <el-option label="已报到" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" class="search-btn-item">
                    <el-button size="mini" @click="searchStudentData">查询</el-button>
                    <el-button size="mini" class="reset-button" @click="resetStudentData">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="training-step4-search-wrap" v-if="activeName === '3'">
            <el-form :inline="true" class="training-search-form">
                <el-form-item label="姓名：">
                    <el-input v-model="signInSearchForm.userName"></el-input>
                </el-form-item>
                <el-form-item label="归属部门：">
                    <el-cascader
                        :options="orgList"
                        placeholder="请选择"
                        :props="{ checkStrictly: true, label: 'name', value: 'id', children: 'orgs' }"
                        v-model="signInSearchForm.orgId"
                        clearable></el-cascader>
                </el-form-item>
                <el-form-item label="" class="search-btn-item">
                    <el-button size="mini" @click="searchSignInData">查询</el-button>
                    <el-button size="mini" class="reset-button" @click="resetSignInData">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="training-step4-search-wrap" v-if="activeName === '4' && studyTab === 1">
            <el-form :inline="true" class="training-search-form training-search-form-spec">
                <el-form-item label="活动名称：">
                    <el-input v-model="activitySearchForm.activityName"></el-input>
                </el-form-item>
                <el-form-item label="选/必修：">
                    <el-select v-model="activitySearchForm.compulsory" placeholder="请选择">
                        <el-option label="" value=""></el-option>
                        <el-option label="必修" :value="1"></el-option>
                        <el-option label="选修" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select v-model="activitySearchForm.status" placeholder="请选择">
                        <el-option label="" value=""></el-option>
                        <el-option label="未开始" :value="1"></el-option>
                        <el-option label="已结束" :value="2"></el-option>
                        <el-option label="进行中" :value="3"></el-option>
                        <!-- <el-option v-for="(item, index) in activityStatus" :key="index" :label="item" :value="index"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item label="活动类型：">
                    <el-select v-model="activitySearchForm.type" placeholder="请选择">
                        <el-option label="" value=""></el-option>
                        <el-option v-for="(item, index) in activityType" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" class="search-btn-item">
                    <el-button size="mini" @click="searchActivityData">查询</el-button>
                    <el-button size="mini" class="reset-button" @click="resetActivityData">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="training-step4-search-wrap" v-if="activeName === '4' && studyTab === 2">
            <el-form :inline="true" class="training-search-form">
                <el-form-item label="姓名：">
                    <el-input v-model="situationSearchForm.userName"></el-input>
                </el-form-item>
                <el-form-item label="结业状态：">
                    <el-select v-model="situationSearchForm.isGraduation" placeholder="请选择">
                        <el-option label="" value=""></el-option>
                        <el-option label="未结业" :value="0"></el-option>
                        <el-option label="已结业" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" class="search-btn-item">
                    <el-button size="mini" @click="searchSituationData">查询</el-button>
                    <el-button size="mini" class="reset-button" @click="resetSituationData">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="training-step4-line" v-if="activeName !== '5'"></div>
        
        <div class="training-step4-btn-wrap" v-if="activeName === '1'">
            <div class="title">报名列表</div>
            <div class="training-step-right-btns">
                <el-button size="mini" @click="signUpMultiAudit" v-if="formData.status !== 7">批量审核</el-button>
                <el-button size="mini" @click="signUpMultiExport">导出</el-button>
            </div>
        </div>
        <div class="training-step4-btn-wrap" v-if="activeName === '2'">
            <div class="title">学员列表</div>
            <div class="training-step-right-btns">
                <el-button size="mini" @click="studentMultiExport">导出</el-button>
            </div>
        </div>
        <div class="training-step4-btn-wrap" v-if="activeName === '3'">
            <div class="title">考勤列表</div>
            <div class="training-step-right-btns">
                <el-button size="mini" @click="signInMultiExport">导出</el-button>
            </div>
        </div>
        <div class="training-step4-btn-wrap" v-if="activeName === '4' && studyTab === 1">
            <div class="title">活动列表</div>
            <div class="training-step-right-btns">
                <el-button size="mini" @click="activityMultiExport">导出</el-button>
            </div>
        </div>
        <div class="training-step4-btn-wrap" v-if="activeName === '4' && studyTab === 2">
            <div class="title">学员列表</div>
            <div class="training-step-right-btns">
                <el-button size="mini" @click="situatioPublish" v-if="formData.status !== 7">批量结业</el-button>
                <el-button size="mini" @click="addMS">导出</el-button>
            </div>
        </div>
        <div class="training-step4-btn-wrap" v-if="activeName === '5'">
            <div class="title">通知列表</div>
            <div class="training-step-right-btns" v-if="formData.status !== 7">
                <el-button size="mini" @click="addContent">添加公告</el-button>
            </div>
        </div>

        <div class="training-step-table" v-if="activeName === '1'">
            <el-table :data="signUpForm.formResult.list" style="width: 100%" key="signUpFormTable" @selection-change="handleSignUpSelectionChange">
                <template slot="empty">
                    <EmptyPage></EmptyPage>
                </template>
                <el-table-column key="signUpFormCol1" type="selection" width="55" v-if="formData.status !== 7"></el-table-column>
                <el-table-column key="signUpFormCol2" type="index" label="序号" width="60"></el-table-column>
                <el-table-column key="signUpFormCol3" prop="userName" label="账号"></el-table-column>
                <el-table-column key="signUpFormCol4" prop="realName" label="姓名"></el-table-column>
                <el-table-column key="signUpFormCol5" prop="orgName" label="所属部门"></el-table-column>
                <el-table-column key="signUpFormCol6" prop="jobName" label="岗位" ></el-table-column>
                <el-table-column key="signUpFormCol7" prop="positionName" label="职务"></el-table-column>
                <el-table-column key="signUpFormCol8" prop="mobile" label="手机号"></el-table-column>
                <el-table-column key="signUpFormCol9" prop="date" label="审核状态">
                    <template slot-scope="scope">
                        <span>{{signUpStatus[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="signUpFormCol10" prop="action" label="操作" v-if="formData.status !== 7">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 0" class="table-btn table-btn-view" @click="signUpAudit(scope.row)">
                            <span>审核</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <pagination key="signUpPage" :form="signUpForm" @request-form-list="trainSignupList"></pagination>
        </div>
        <div class="training-step-table" v-if="activeName === '2'">
            <el-table :data="studentForm.formResult.list" style="width: 100%" key="studentFormTable">
                <template slot="empty">
                    <EmptyPage></EmptyPage>
                </template>
                <el-table-column key="studentFormCol1" type="selection" width="55"></el-table-column>
                <el-table-column key="studentFormCol2" type="index" label="序号"></el-table-column>
                <el-table-column key="studentFormCol3" prop="username" label="账号"></el-table-column>
                <el-table-column key="studentFormCol4" prop="realname" label="姓名"></el-table-column>
                <el-table-column key="studentFormCol5" prop="orgName" label="所属部门"></el-table-column>
                <el-table-column key="studentFormCol6" prop="jobName" label="岗位" ></el-table-column>
                <el-table-column key="studentFormCol7" prop="positionName" label="职务"></el-table-column>
                <el-table-column key="studentFormCol8" prop="mobile" label="手机号"></el-table-column>
                <el-table-column key="studentFormCol9" prop="status" label="报到状态">
                    <template slot-scope="scope">
                        <span>{{scope.row.status ? '已报到' : '未报到'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" v-if="formData.status !== 7">
                    <template slot-scope="scope">
                        <div class="table-btn table-btn-view" @click="deleteStudentItem(scope.row)">
                            <span>删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <pagination key="studentPage" :form="studentForm" @request-form-list="studentList"></pagination>
        </div>
        <div class="training-step-table" v-if="activeName === '3'">
            <el-table :data="signInForm.formResult.list" style="width: 100%" key="signInFormTable">
                <template slot="empty">
                    <EmptyPage></EmptyPage>
                </template>
                <el-table-column key="signInFormCol1" type="selection" width="55"></el-table-column>
                <el-table-column key="signInFormCol2" type="index" label="序号"></el-table-column>
                <el-table-column key="signInFormCol3" prop="userName" label="账号">
                    <template slot-scope="scope">
                        <div class="table-btn table-btn-view" style="cursor: none;">
                            <span>{{scope.row.userName}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column key="signInFormCol4" prop="realName" label="姓名"></el-table-column>
                <el-table-column key="signInFormCol5" prop="orgName" label="所属部门"></el-table-column>
                <el-table-column key="signInFormCol6" prop="jobName" label="岗位" ></el-table-column>
                <el-table-column key="signInFormCol7" prop="positionName" label="职务"></el-table-column>
                <el-table-column key="signInFormCol8" prop="createTime" label="签到时间"></el-table-column>
                <el-table-column key="signInFormCol9" prop="" label="签到状态">
                    <template slot-scope="scope">
                        <span>已完成</span>
                    </template>
                </el-table-column>
            </el-table>
            <pagination key="signInPage" :form="signInForm" @request-form-list="trainSigninList"></pagination>
        </div>
        <div class="training-step-table" v-if="activeName === '4' && studyTab === 1">
            <el-table :data="activityForm.formResult.list" style="width: 100%" key="activityFormTable">
                <template slot="empty">
                    <EmptyPage></EmptyPage>
                </template>
                <el-table-column key="activityFormCol1" type="selection" width="55"></el-table-column>
                <el-table-column key="activityFormCol2" type="index" label="序号"></el-table-column>
                <el-table-column key="activityFormCol3" prop="activityName" label="活动名称"></el-table-column>
                <el-table-column key="activityFormCol4" prop="compulsory" label="选/必修">
                    <template slot-scope="scope">
                        <span>{{scope.row.compulsory?'必修':'选修'}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="activityFormCol5" prop="type" label="活动类型">
                    <template slot-scope="scope">
                        <span>{{activityType[scope.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="activityFormCol6" prop="startTime" label="开始时间" width="160"></el-table-column>
                <el-table-column key="activityFormCol7" prop="endTime" label="结束时间" width="160"></el-table-column>
                <el-table-column key="activityFormCol8" prop="status" label="状态">
                    <template slot-scope="scope">
                        <span>{{activityStatus[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="activityFormCol9" prop="" label="完成情况">
                    <template slot-scope="scope">
                        <span>{{scope.row.completeNum+'/'+scope.row.userNum}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="activityFormCol10" prop="action" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type === 1 || scope.row.type === 3 || scope.row.type === 4" class="table-btn table-btn-view" @click="activityView(scope.row)">
                            <span>详情</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="training-step-table" v-if="activeName === '4' && studyTab === 2">
            <el-table :data="situationForm.formResult.list" style="width: 100%" key="situationFormTable" @selection-change="handleSituationSelectionChange">
                <template slot="empty">
                    <EmptyPage></EmptyPage>
                </template>
                <el-table-column key="situationFormCol1" type="selection" width="55" v-if="formData.status !== 7"></el-table-column>
                <el-table-column key="situationFormCol2" type="index" label="序号"></el-table-column>
                <el-table-column key="situationFormCol3" prop="realname" label="姓名"></el-table-column>
                <el-table-column key="situationFormCol4" prop="username" label="账号"></el-table-column>
                <el-table-column key="situationFormCol5" prop="orgName" label="归属部门"></el-table-column>
                <el-table-column key="situationFormCol6" prop="completeMustNum" label="必修完成情况">
                    <template slot-scope="scope">
                        <span>{{scope.row.mustNum + '/' + scope.row.completeMustNum}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="situationFormCol7" prop="completeTakeNum" label="选修完成情况">
                    <template slot-scope="scope">
                        <span>{{scope.row.takeNum + '/' + scope.row.completeTakeNum}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="situationFormCol8" prop="status" label="报到情况" width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.status ? '已报到' : '未报到'}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="situationFormCol9" prop="action" label="签到情况">
                    <template slot-scope="scope">
                        <div class="table-btn table-btn-view" @click="situationSign(scope.row)">
                            <span>查看</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column key="situationFormCol10" prop="time" label="总学习时长"></el-table-column>
                <el-table-column key="situationFormCol11" prop="isGraduation" label="结业状态">
                    <template slot-scope="scope">
                        <el-select v-if="formData.status !== 7 && !scope.row.isGraduation" v-model="scope.row.isGraduation" placeholder="请选择" @change="trainClassPublish([scope.row.id])">
                            <!-- <el-option label="" value=""></el-option> -->
                            <el-option label="未结业" :value="0"></el-option>
                            <el-option label="已结业" :value="1"></el-option>
                        </el-select>
                        <span v-if="formData.status === 7 || scope.row.isGraduation">{{scope.row.isGraduation ? '已结业':'未结业'}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="situationFormCol12" prop="certId" label="获得证书">
                    <template slot-scope="scope">
                        <span>{{scope.row.certId ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <pagination key="situationPage" :form="situationForm" @request-form-list="situationList"></pagination>
        </div>
        <div class="training-step-table" v-if="activeName === '5'">
            <el-table :data="contentForm.formResult.list" style="width: 100%" key="contentFormTable">
                <template slot="empty">
                    <EmptyPage></EmptyPage>
                </template>
                <el-table-column key="contentFormCol1" type="index" label="序号"></el-table-column>
                <el-table-column key="contentFormCol2" prop="title" label="公告标题" width="210"></el-table-column>
                <el-table-column key="contentFormCol3" prop="createTime" label="发布时间"></el-table-column>
                <el-table-column key="contentFormCol4" prop="userName" label="发布人" width="168"></el-table-column>
                <el-table-column key="contentFormCol5" prop="action" label="操作" width="150" v-if="formData.status !== 7">
                    <template slot-scope="scope">
                        <!-- <div class="table-btn table-btn-view">
                            <i class="el-icon-view"></i>
                            <span>查看</span>
                        </div> -->
                        <div class="table-btn table-btn-view" @click="editContentItem(scope.row)">
                            <!-- <i class="el-icon-edit"></i> -->
                            <span>编辑</span>
                        </div>
                        <div class="table-btn table-btn-delete" @click="deleteContentItem(scope.row)">
                            <!-- <i class="el-icon-delete"></i> -->
                            <span>删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <pagination key="contentPage" :form="contentForm" @request-form-list="trainContentList"></pagination>
        </div>

        <!-- 报名审核 -->
        <el-dialog
            title="报名审核"
            :visible.sync="signUpDialog.visible1"
            width="5rem"
            class="step-audit-dialog step-signup-dialog"
            key="signup1"
            :before-close="handleSignUpDialogClose">
            <div class="step-signup-form">
                <div class="step-signup-form-item"><span class="title">账号：</span><span class="content">{{signUpDialog.form.userName}}</span></div>
                <div class="step-signup-form-item"><span class="title">姓名：</span><span class="content">{{signUpDialog.form.realName}}</span></div>
                <div class="step-signup-form-item"><span class="title">归属部门：</span><span class="content">{{signUpDialog.form.orgName}}</span></div>
                <div class="step-signup-form-item"><span class="title">岗位：</span><span class="content">{{signUpDialog.form.jobName}}</span></div>
                <div class="step-signup-form-item"><span class="title">职务：</span><span class="content">{{signUpDialog.form.positionName}}</span></div>
                <div class="step-signup-form-item"><span class="title">手机号：</span><span class="content">{{signUpDialog.form.mobile}}</span></div>

            </div>
            <div class="dialog-footer">
                <el-button size="mini" @click="handleSignupDialogAudit(2)">拒绝</el-button>
                <el-button type="success" size="mini" @click="handleSignupDialogAudit(1)">通过</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="报名审核"
            :visible.sync="signUpDialog.visible2"
            width="5rem"
            class="step-audit-dialog step-signup-dialog"
            key="signup2"
            :before-close="handleSignUpDialogClose">
            <div class="step-signup-multi">
                共选中{{signUpSelectedList ? signUpSelectedList.length : ''}}人进行批量审核！
            </div>
            <div class="dialog-footer">
                <el-button size="mini" @click="handleSignupMultiDialogAudit(2)">拒绝</el-button>
                <el-button type="success" size="mini" @click="handleSignupMultiDialogAudit(1)">通过</el-button>
            </div>
        </el-dialog>

        <!-- 签到 -->
        <el-dialog
            title="签到记录"
            :visible.sync="signInDialog.visible"
            width="7.7rem"
            class="step-audit-dialog"
            key="signindialog"
            :before-close="handleSignInDialogClose">
            <div class="step-signup-num">
                共签到{{signInDialog.form.formResult.total}}天
            </div>
            <div class="training-step-table">
                <el-table :data="signInDialog.form.formResult.list" style="width: 100%" key="signInDialogtable">
                    <el-table-column prop="createTime" key="signInDialogcol1" show-overflow-tooltip label="签到时间"></el-table-column>
                    <el-table-column prop="" key="signInDialogcol2" label="结果">
                        <template slot-scope="scope">
                            <span>签到成功</span>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination key="signInDialogpage" @request-form-list="querySituationSign" :form="signInDialog.form"></pagination>
            </div>
        </el-dialog>

        <!-- 课程 -->
        <el-dialog
            title="课程学习情况"
            :visible.sync="actCourseDialog.visible"
            width="11.8rem"
            class="step-audit-dialog"
            key="actCourseDialog"
            :before-close="handleActCourseDialogClose">
            <div class="act-detail-top">
                <div class="act-detail-top-left">课程名称：{{actCourseDialog.detail.activityName}}</div>
                <div class="act-detail-top-right">
                    未学习人数：<span style="color: #FE6A60;margin-right: 0.4rem;">{{actCourseDialog.detail.learnNum}}</span>
                    学习中人数：<span style="color: #0E3092;margin-right: 0.4rem;">{{actCourseDialog.detail.studyNum}}</span>
                    已完成人数：<span style="color: #2DCF3E;">{{actCourseDialog.detail.finishNum}}</span>
                </div>
            </div>
            <el-form :model="actCourseDialog.form" :inline="true" label-width="82px" key="3" class="user-step-search-form">
                <el-form-item label="姓名：" prop="realname">
                    <el-input v-model="actCourseDialog.form.realname"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="username">
                    <el-input v-model="actCourseDialog.form.username"></el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-select v-model="actCourseDialog.form.status" placeholder="请选择">
                        <el-option v-for="(item, index) in actCourseDialog.statusType" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" class="search-itrm-btn">
                    <el-button size="mini" @click="handleactCourseDialogSearch">查询</el-button>
                    <el-button size="mini" class="reset-btn" @click="handleactCourseDialogReset">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="training-step-table">
                <el-table :data="actCourseDialog.tableForm.formResult.list" style="width: 100%" key="actcoursetable1">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column prop="realname" label="姓名"></el-table-column>
                    <el-table-column prop="username" label="账号"></el-table-column>
                    <el-table-column prop="orgName" label="归属部门"></el-table-column>
                    <el-table-column prop="time" label="总学习时长" width="168"></el-table-column>
                    <el-table-column prop="status" label="完成状态">
                        <template slot-scope="scope">
                            <span>{{actCourseDialog.statusType[scope.row.status]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination key="actcoursepage" @request-form-list="trainCourseList" :form="actCourseDialog.tableForm"></pagination>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleActCourseDialogClose">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 调研详情 -->
        <el-dialog
            title="调研详情"
            :visible.sync="actQueDialog.visible"
            width="11.8rem"
            class="step-audit-dialog"
            key="actQueDialog"
            :before-close="handleActQueDialogClose">
            <div class="act-detail-top">
                <div class="act-detail-top-left">调研名称：{{actQueDialog.detail.title}}</div>
                <div class="act-detail-top-right">已参加人数：{{actQueDialog.detail.num}}</div>
            </div>
            <el-form :model="actQueDialog.form" :inline="true" label-width="82px" key="3" class="user-step-search-form">
                <el-form-item label="姓名：" prop="realname">
                    <el-input v-model="actQueDialog.form.realname"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="username">
                    <el-input v-model="actQueDialog.form.username"></el-input>
                </el-form-item>
                <el-form-item label="提交时间：" prop="createTimeRange">
                    <el-date-picker v-model="actQueDialog.form.createTimeRange" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                </el-form-item>
                <el-form-item label="" class="search-itrm-btn">
                    <el-button size="mini" @click="handleactQueDialogSearch">查询</el-button>
                    <el-button size="mini" class="reset-btn" @click="handleactQueDialogReset">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="training-step-table">
                <el-table :data="actQueDialog.tableForm.formResult.list" style="width: 100%" key="actquetable">
                    <el-table-column key="actquecol1" type="index" label="序号"></el-table-column>
                    <el-table-column key="actquecol2" prop="realname" label="姓名"></el-table-column>
                    <el-table-column key="actquecol3" prop="username" label="账号"></el-table-column>
                    <el-table-column key="actquecol4" prop="orgName" label="归属部门"></el-table-column>
                    <el-table-column key="actquecol5" prop="createTime" label="提交时间" width="168"></el-table-column>
                </el-table>
                <pagination key="actquepage" @request-form-list="querySurveySubList" :form="actQueDialog.tableForm"></pagination>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleActQueDialogClose">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 考试详情 -->
        <el-dialog
            title="考试详情"
            :visible.sync="actExamDialog.visible"
            width="11.8rem"
            class="step-audit-dialog"
            key="actExamDialog"
            :before-close="handleActExamDialogClose">
            <div class="act-detail-top">
                <div class="act-detail-top-item">考试名称：{{actExamDialog.detail.title}}</div>
                <div class="act-detail-top-item">考试开始时间：{{actExamDialog.detail.joinStartTime}}</div>
                <div class="act-detail-top-item">考试结束时间：{{actExamDialog.detail.joinEndTime}}</div>
                <div class="act-detail-top-item">线上考试及格分数：{{actExamDialog.detail.passScore}}</div>
                <div class="act-detail-top-item">线上考试及格人数：{{actExamDialog.detail.passNum}}</div>
                <div class="act-detail-top-item">线上考试及格率：{{actExamDialog.detail.passRate}}</div>
            </div>
            <el-form :model="actExamDialog.form" :inline="true" label-width="82px" key="3" class="user-step-search-form">
                <el-form-item label="姓名：" prop="realname">
                    <el-input v-model="actExamDialog.form.realname"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="username">
                    <el-input v-model="actExamDialog.form.username"></el-input>
                </el-form-item>
                <el-form-item label="" class="search-itrm-btn">
                    <el-button size="mini" @click="handleactExamDialogSearch">查询</el-button>
                    <el-button size="mini" class="reset-btn" @click="handleactExamDialogReset">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="training-step-table">
                <el-table :data="actExamDialog.tableForm.formResult.list" style="width: 100%" key="actexamtable">
                    <el-table-column key="actexamcol1" type="index" label="序号"></el-table-column>
                    <el-table-column key="actexamcol2" prop="realname" label="姓名"></el-table-column>
                    <el-table-column key="actexamcol4" prop="deptName" label="归属部门"></el-table-column>
                    <el-table-column key="actexamcol3" prop="score" label="线上成绩"></el-table-column>
                    <el-table-column key="actexamcol5" prop="credits" label="总分"></el-table-column>
                    <el-table-column key="actexamcol6" prop="status" label="完成状态">
                        <template slot-scope="scope">
                            <span>{{scope.row.status?'已提交':'未提交'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column key="actexamcol7" prop="action" label="操作">
                        <template slot-scope="scope">
                            <div class="table-btn table-btn-view" @click="actExamDialogItem(scope.row)">
                                <span>明细</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination key="actexampage" @request-form-list="trainExamDetailList" :form="actExamDialog.tableForm"></pagination>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleActExamDialogClose">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 考试详情明细 -->
        <el-dialog
            title="考试详情明细"
            :visible.sync="actExamDetailDialog.visible"
            width="11.8rem"
            class="step-audit-dialog"
            key="actExamDetailDialog"
            :before-close="handleActExamDetailDialogClose">
            <div class="act-detail-top">
                <div class="act-detail-top-item">考生姓名：{{actExamDetailDialog.row.realname}}</div>
                <div class="act-detail-top-item">归属部门：{{actExamDetailDialog.row.deptName}}</div>
            </div>
            <el-form :model="actExamDetailDialog.form" :inline="true" label-width="82px" key="3" class="user-step-search-form">
                <el-form-item label="开始时间：" prop="realname" style="margin-left: 20px;">
                    <el-date-picker v-model="actExamDetailDialog.form.startTimeRange" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                </el-form-item>
                <el-form-item label="交卷时间：" prop="username">
                    <el-date-picker v-model="actExamDetailDialog.form.endTimeRange"  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                </el-form-item>
                <el-form-item label="" class="search-itrm-btn">
                    <el-button size="mini" @click="handleactExamDetailDialogSearch">查询</el-button>
                    <el-button size="mini" class="reset-btn" @click="handleactExamDetailDialogReset">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="training-step-table">
                <el-table :data="actExamDetailDialog.tableForm.formResult.list" style="width: 100%" key="actexamtableqq">
                    <el-table-column key="actexamcolq1" type="index" label="序号"></el-table-column>
                    <el-table-column key="actexamcolq2" prop="startTime" label="开始时间"></el-table-column>
                    <el-table-column key="actexamcolq4" prop="endTime" label="交卷时间"></el-table-column>
                    <el-table-column key="actexamcolq3" prop="limitTime" label="用时（分钟）"></el-table-column>
                    <el-table-column key="actexamcolq5" prop="examScore" label="线上成绩"></el-table-column>
                    <el-table-column key="actexamcolq6" prop="examLevel" label="状态">
                        <template slot-scope="scope">
                            <span>{{actExamDetailDialog.examLevel[scope.row.examLevel]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination key="actexampageqq" @request-form-list="trainExamDetailList" :form="actExamDetailDialog.tableForm"></pagination>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleActExamDetailDialogClose">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 通知 -->
        <el-dialog
            title="添加公告"
            :visible.sync="contentDialog.visible"
            width="7.7rem"
            class="step-audit-dialog"
            key="content"
            :before-close="handleContentDialogClose">
            <el-form :model="contentDialog.form" :rules="contentDialog.rules" ref="contentDialogForm" label-width="200px" key="contentdform" class="user-step-dialog-form">
                <el-form-item key="contentdform1" label="公告标题：" prop="title">
                    <el-input v-model="contentDialog.form.title" placeholder="请输入公告标题"></el-input>
                </el-form-item>
                <el-form-item key="contentdform2" label="公告内容：" prop="info" class="step4-content-item">
                    <el-input v-model="contentDialog.form.info" type="textarea" placeholder="请输入公告内容"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleContentDialogSave('contentDialogForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import EmptyPage from '@/components/emptyPage'
import pagination from '@/components/pagination/index'
import { mapGetters } from 'vuex'
// import { stat } from 'fs'

export default {
    name: 'TrainingStep4',
    props: ['formData'],
    components: { EmptyPage, pagination },
    computed: {
        ...mapGetters([
        'userInfo'
        ])
    },
    data() {
        return {
            rules: {},
            namell: '',
            activeName: '1',
            studyTab: 1,
            orgList: [],
            // 报名
            signUpStatus: {0: '待审核', 1: '审核通过', 2: '未通过'},
            signUpSearchForm: {
                orgId: [],
                status: '',
                userName: ''
            },
            signUpSelectedList: null,
            signUpForm: {
                formResult: { currentPage: 1, total: 0, list: [] },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            signUpDialog: {
                visible1: false,
                visible2: false,
                form: {} 
            },
            // 学员
            studentSearchForm: {
                orgId: '',
                status: '',
                userName: ''
            },
            studentForm: {
                formResult: { currentPage: 1, total: 0, list: [] },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            // 考勤
            signInSearchForm: {
                orgId: [],
                userName: ''
            },
            signInForm: {
                formResult: { currentPage: 1, total: 0, list: [] },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            // 学习-活动情况
            activitySearchForm: {
                activityName: '',
                compulsory: '',
                status: '',
                type: ''
            },
            activityForm: {
                formResult: { currentPage: 1, total: 0, list: [] },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            activityType: {1: '课程', 2: '作业', 3: '调研', 4: '考试', 5: '面授'},
            activityStatus: {0: '',1: '未开始',2: '已结束',3: '进行中'},
            actCourseDialog: {
                visible: false,
                detail: { title: '' },
                form: { realname: '', username: '', status: 0 },
                row: {},
                tableForm: {
                    formResult: { currentPage: 1, total: 0, list: [] },
                    pageData: { currentPage: 1, pageSize: 5, sortName: '', sortOrder: '' }
                },
                statusType: { 1: '未开始', 2: '进行中', 3: '已完成'},
            },
            actQueDialog: {
                visible: false,
                detail: { title: '' },
                form: { realname: '', username: '', createTimeRange: [] },
                row: {},
                tableForm: {
                    formResult: { currentPage: 1, total: 0, list: [] },
                    pageData: { currentPage: 1, pageSize: 5, sortName: '', sortOrder: '' }
                }
            },
            actExamDialog: {
                visible: false,
                detail: { title: '' },
                form: { realname: '', username: '' },
                row: {},
                tableForm: {
                    formResult: { currentPage: 1, total: 0, list: [] },
                    pageData: { currentPage: 1, pageSize: 5, sortName: '', sortOrder: '' }
                }
            },
            actExamDetailDialog: {
                visible: false,
                form: { startTimeRange: [], endTimeRange: [] },
                row: {},
                tableForm: {
                    formResult: { currentPage: 1, total: 0, list: [] },
                    pageData: { currentPage: 1, pageSize: 5, sortName: '', sortOrder: '' }
                },
                examLevel: { 0: '',1: '及格',2: '良好',3: '优秀' }
            },
            // 学习-学生情况
            situationSearchForm: {
                orgId: '',
                userName: '',
                status: '',
                isGraduation: ''
            },
            situationForm: {
                formResult: { currentPage: 1, total: 0, list: [] },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            situationSelectedList: null,
            signInDialog: {
                visible: false,
                row: {},
                form: {
                    formResult: { currentPage: 1, total: 0, list: [] },
                    pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
                }
            },
            // 通知
            contentForm: {
                formResult: { currentPage: 1, total: 0, list: [] },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            contentDialog: {
                visible: false,
                form: {
                    title: '',
                    info: ''
                },
                rules: {
                    title: [
                        { required: true, message: '请输入公告标题', trigger: 'change' },
                    ],
                    info: [
                        { required: true, message: '请输入公告内容', trigger: 'change' },
                    ]
                }
            }
        }
    },
    mounted() {
       this.initPage() 
    },
    methods: {
        handleTabChange() {
            if (this.activeName === '4') {
                this.changeStudyTab(this.studyTab)
            }
        },
        changeStudyTab(a) {
            this.studyTab = a
            if (a === 1) {
                this.resetActivityData()
            }
            if (a === 2) {
                this.resetSituationData()
            }
        },
        // 初始化页面
        initPage() {
            this.getOrgTreeList()
            this.trainSignupList() // 报名
            this.studentList() // 学员
            this.trainSigninList() // 签到
            this.trainContentList() // 通知
        },
        // 报名管理查询
        searchSignData() {
            this.signUpForm.pageData.currentPage = 1
            this.trainSignupList()
        },
        // 报名管理重置
        resetSignData() {
            this.signUpSearchForm.orgId = []
            this.signUpSearchForm.status = ''
            this.signUpSearchForm.userName = ''
            this.signUpForm.pageData.currentPage = 1
            this.trainSignupList()
        },
        // 报名选择
        handleSignUpSelectionChange(data) {
            this.signUpSelectedList = data
        },
        // 报名批量审核
        signUpMultiAudit() {
            if (!this.signUpSelectedList) {
                this.$message({message: '请选择数据', type: 'warning'})
                return
            }
            for (let item of this.signUpSelectedList) {
                if (item.status === 1 || item.status === 2) {
                    this.$message({message: '选择数据中包含已审核数据，不能重复审核', type: 'warning'})
                    return
                }
            }
            this.signUpDialog.visible2 = true
        },
        // 报名审核
        signUpAudit(row) {
            this.signUpDialog.form = row
            this.signUpDialog.visible1 = true
        },
        handleSignupDialogAudit(status) {
            this.$api.user.train.trainSignupPublish({
                id: this.signUpDialog.form.id,
                status: status
            }).then(res => {
                this.$message({message: '操作成功', type: 'success'})
                this.trainSignupList()
                this.handleSignUpDialogClose()
            })
        },
        // 批量审核
        handleSignupMultiDialogAudit(status) {
            let params = []
            for(let item of this.signUpSelectedList) {
                params.push({id:item.id, status: status})
            }
            this.$api.user.train.trainSignupPublishList(params).then(res => {
                this.$message({message: '操作成功', type: 'success'})
                this.trainSignupList()
                this.handleSignUpDialogClose()
                this.signUpSelectedList = null
            })
        },
        // 报名导出
        signUpMultiExport() {
            const _timer = (new Date()).getTime()
            const _fileName = '报名列表' + _timer + '.xlsx'
            this.$wtUtil.downloadFile({
                url: '/train/api/trainClass/trainSignupExcel',
                fileName: _fileName,
                data: {
                    orgId: this.signUpSearchForm.orgId.length > 0 ? this.signUpSearchForm.orgId[this.signUpSearchForm.orgId.length-1] : '',
                    status: this.signUpSearchForm.status,
                    trainId: this.$route.query.id,
                    userName: this.signUpSearchForm.userName
                }
            })
        },
        // 报名审核关闭
        handleSignUpDialogClose() {
            this.signUpDialog.visible1 = false
            this.signUpDialog.visible2 = false
        },
        // 报名管理
        trainSignupList() {
            this.$api.user.train.trainSignupList({
                formData: {
                    orgId: this.signUpSearchForm.orgId.length > 0 ? this.signUpSearchForm.orgId[this.signUpSearchForm.orgId.length-1] : '',
                    status: this.signUpSearchForm.status,
                    trainId: this.$route.query.id,
                    userName: this.signUpSearchForm.userName
                },
                pageData: this.signUpForm.pageData
            }).then(res => {
                this.signUpForm.formResult = res.data
            })
        },

        // 学员管理-查询
        searchStudentData() {
            this.studentForm.pageData.currentPage = 1
            this.studentList()
        },
        // 学员管理-重置
        resetStudentData() {
            this.studentSearchForm.orgId = ''
            this.studentSearchForm.status = ''
            this.studentSearchForm.userName = ''
            this.studentForm.pageData.currentPage = 1
            this.studentList()
        },
        // 学员管理-导出
        studentMultiExport() {
            const _timer = (new Date()).getTime()
            const _fileName = '学员列表' + _timer + '.xlsx'
            this.$wtUtil.downloadFile({
                url: '/train/api/trainClass/trainStudentExcel',
                fileName: _fileName,
                data: {
                    orgId: this.studentSearchForm.orgId.length > 0 ? this.studentSearchForm.orgId[this.studentSearchForm.orgId.length-1] : '',
                    status: this.studentSearchForm.status,
                    trainId: this.$route.query.id,
                    userName: this.studentSearchForm.userName
                }
            })
        },
        // 学员管理-列表
        studentList() {
            this.$api.user.train.studentList({
                formData: {
                    orgId: this.studentSearchForm.orgId.length > 0 ? this.studentSearchForm.orgId[this.studentSearchForm.orgId.length-1] : '',
                    status: this.studentSearchForm.status,
                    trainId: this.$route.query.id,
                    userName: this.studentSearchForm.userName
                },
                pageData: this.studentForm.pageData
            }).then(res => {
                this.studentForm.formResult = res.data
            })
        },
        // 学员管理-删除
        deleteStudentItem(row) {
            this.$confirm('确定删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.user.train.trainSignupDelete({
                    list: [row.id]
                }).then(res => {
                    this.$message({message: '删除成功', type: 'success'})
                    this.studentList()
                })
            }).catch(() => {})
        },


        // 考勤-查询
        searchSignInData() {
            this.signInForm.pageData.currentPage = 1
            this.trainSigninList()
        },
        // 考勤-重置
        resetSignInData() {
            this.signInSearchForm.orgId = ''
            this.signInSearchForm.userName = ''
            this.signInForm.pageData.currentPage = 1
            this.trainSigninList()
        },
        // 考勤-导出
        signInMultiExport() {
            const _timer = (new Date()).getTime()
            const _fileName = '考勤列表' + _timer + '.xlsx'
            this.$wtUtil.downloadFile({
                url: '/train/api/trainClass/trainSigninExcel',
                fileName: _fileName,
                data: {
                    trainId: this.$route.query.id,
                    userId: this.userInfo.id
                }
            })
        },
        // 考勤-列表
        trainSigninList() {
            this.$api.user.train.trainSigninList({
                formData: {
                    orgId: this.signInSearchForm.orgId.length > 0 ? this.signInSearchForm.orgId[this.signInSearchForm.orgId.length-1] : '',
                    trainId: this.$route.query.id,
                    // userId: this.userInfo.id,
                    userName: this.signInSearchForm.userName
                },
                pageData: this.signInForm.pageData
            }).then(res => {
                this.signInForm.formResult = res.data
            })
        },

        // 学习管理-活动情况-查询
        searchActivityData() {
            this.trainActivityList()
        },
        // 学习管理-活动情况-重置
        resetActivityData() {
            this.activitySearchForm.activityName = ''
            this.activitySearchForm.compulsory = ''
            this.activitySearchForm.status = ''
            this.activitySearchForm.type = ''
            this.activityForm.pageData.currentPage = 1
            this.trainActivityList()
        },
        // 学习管理-活动情况-导出
        activityMultiExport() {
            const _timer = (new Date()).getTime()
            const _fileName = '活动情况列表' + _timer + '.xlsx'
            this.$wtUtil.downloadFile({
                url: '/train/api/trainClass/trainActivityExcel',
                fileName: _fileName,
                data: {
                    trainId: this.$route.query.id,
                    type: this.activitySearchForm.type,
                    activityName: this.activitySearchForm.activityName,
                    compulsory: this.activitySearchForm.compulsory,
                    status: this.activitySearchForm.status
                }
            })
        },
        // 学习管理-活动情况-详情
        activityView(row) {
            if (row.type === 1) {
                this.actCourseDialog.row = row
                this.trainCourseDetails(row.id)
                this.handleactCourseDialogReset()
                this.actCourseDialog.visible = true
            }
            if (row.type === 3) {
                this.actQueDialog.row = row
                this.surveySubDetail(row)
                this.querySurveySubList()
                this.actQueDialog.visible = true
            }
            if (row.type === 4) {
                this.actExamDialog.row = row
                this.trainExamDetail(row.targetId)
                this.handleactExamDialogSearch()
                this.actExamDialog.visible = true
            }
        },
        handleActCourseDialogClose() {
            this.actCourseDialog.visible = false
        },
        handleactCourseDialogSearch() {
            this.actCourseDialog.tableForm.pageData.currentPage = 1
            this.trainCourseList()
        },
        handleactCourseDialogReset() {
            this.actCourseDialog.form.status = ''
            this.actCourseDialog.form.realname = ''
            this.actCourseDialog.form.username = ''
            this.handleactCourseDialogSearch()
        },
        handleActQueDialogClose() {
            this.actQueDialog.visible = false
        },
        handleactQueDialogSearch() {
            this.actQueDialog.tableForm.pageData.currentPage = 1
            this.querySurveySubList()
        },
        handleactQueDialogReset() {
            this.actQueDialog.form.createTimeRange = []
            this.actQueDialog.form.realname = ''
            this.actQueDialog.form.username = ''
            this.handleactQueDialogSearch()
        },
        handleActExamDialogClose() {
            this.actExamDialog.visible = false
        },
        handleactExamDialogSearch() {
            this.actExamDialog.tableForm.pageData.currentPage = 1
            this.trainExamDetailList()
        },
        handleactExamDialogReset() {
            this.actExamDialog.form.realname = ''
            this.actExamDialog.form.username = ''
            this.handleactExamDialogSearch()
        },
        actExamDialogItem(row) {
            this.actExamDetailDialog.row = row
            this.handleactExamDetailDialogReset()
            this.actExamDetailDialog.visible = true
        },
        handleActExamDetailDialogClose() {
            this.actExamDetailDialog.visible = false
        },
        handleactExamDetailDialogSearch() {
            this.actExamDetailDialog.tableForm.pageData.currentPage = 1
            this.trainExamDetailDetail()
        },
        handleactExamDetailDialogReset() {
            this.actExamDetailDialog.form.endTimeRange = []
            this.actExamDetailDialog.form.startTimeRange = []
            this.handleactExamDetailDialogSearch()
        },
        // 活动详情-课程
        trainCourseDetails(id) {
            this.$api.user.train.trainCourseDetails({id:id}).then(res => {
                this.actCourseDialog.detail = res.data
            })
        },
        trainCourseList() {
            this.$api.user.train.trainCourseList({
                formData: {
                    trainId: this.$route.query.id,
                    courseId: this.actCourseDialog.row.targetId,
                    status: this.actCourseDialog.form.status,
                    realname: this.actCourseDialog.form.realname,
                    username: this.actCourseDialog.form.username
                },
                pageData: this.actCourseDialog.tableForm.pageData
            }).then(res => {
                this.actCourseDialog.tableForm.formResult = res.data
            })
        },
        // 活动详情-调研
        surveySubDetail(row) {
            this.$api.user.train.quesSubDetail({
                id: row.targetId,
                quesDataId: row.id
            }).then(res => {
                this.actQueDialog.detail = res.data
            })
        },
        querySurveySubList() {
            this.$api.user.train.adminList({
                formData: {
                    trainId: this.$route.query.id,
                    quesId: this.actQueDialog.row.targetId,
                    quesDataId: this.actQueDialog.row.id,
                    createTimeRange: this.actQueDialog.form.createTimeRange,
                    realname: this.actQueDialog.form.realname,
                    username: this.actQueDialog.form.username
                },
                pageData: this.actQueDialog.tableForm.pageData
            }).then(res => {
                this.actQueDialog.tableForm.formResult = res.data
            })
        },
        // 活动详情-考试
        trainExamDetail(id) {
            this.$api.user.train.trainExamDetail({id:id}).then(res => {
                this.actExamDialog.detail = res.data
            })
        },
        trainExamDetailList() {
            this.$api.user.train.trainExamDetailList({
                formData: {
                    trainId: this.$route.query.id,
                    examId: this.actExamDialog.row.targetId,
                    realname: this.actExamDialog.form.realname,
                    username: this.actExamDialog.form.username
                },
                pageData: this.actExamDialog.tableForm.pageData
            }).then(res => {
                this.actExamDialog.tableForm.formResult = res.data
            })
        },
        trainExamDetailDetail() {
            this.$api.user.exam.trainExamDetailDetail({
                formData: {
                    examId: this.actExamDialog.row.targetId,
                    id: this.actExamDialog.row.targetId,
                    userId: this.actExamDetailDialog.row.userId,
                    endTimeRange: this.actExamDetailDialog.form.endTimeRange,
                    startTimeRange: this.actExamDetailDialog.form.startTimeRange
                },
                pageData: this.actExamDetailDialog.tableForm.pageData
            }).then(res => {
                this.actExamDetailDialog.tableForm.formResult = res.data
            })
        },
        // 学习管理-活动情况-列表
        trainActivityList() {
            this.$api.user.train.activityManagementList({
                formData: {
                    trainId: this.$route.query.id,
                    type: this.activitySearchForm.type,
                    activityName: this.activitySearchForm.activityName,
                    compulsory: this.activitySearchForm.compulsory,
                    status: this.activitySearchForm.status
                },
                pageData: this.activityForm.pageData
            }).then(res => {
                this.activityForm.formResult = res.data
            })
        },

        // 学习管理-学员情况-查询
        searchSituationData() {
            this.situationForm.pageData.currentPage = 1
            this.situationList()
        },
        // 学习管理-学员情况-重置
        resetSituationData() {
            this.situationSearchForm.isGraduation = ''
            this.situationSearchForm.userName = ''
            this.situationSearchForm.orgId = ''
            this.situationForm.pageData.currentPage = 1
            this.situationList()
        },
        handleSituationSelectionChange(data) {
            this.situationSelectedList = data
        },
        // 批量结业
        situatioPublish() {
            if (!this.situationSelectedList) {
                this.$message({message: '请选择数据', type: 'warning'})
                return
            }
            let list = []
            for (let item of this.situationSelectedList) {
                if (item.isGraduation === 1) {
                    this.$message({message: '选择数据中包含已结业数据，不能重复结业', type: 'warning'})
                    return
                }
                list.push(item.id)
            }
            this.trainClassPublish(list)
        },
        situationSign(row) {
            this.signInDialog.row = row
            this.signInDialog.form.pageData.currentPage = 1
            this.querySituationSign()
            this.signInDialog.visible = true           
        },
        handleSignInDialogClose() {
            this.signInDialog.visible = false
        },
        // 结业
        trainClassPublish(list) {
            this.$api.user.train.trainClassPublish({
                list: list
            }).then(res => {
                this.$message({message: '操作成功', type: 'success'})
                this.situationSelectedList = null
                this.situationList()
            })
        },
        querySituationSign() {
            this.$api.user.train.trainSigninList({
                formData: {
                    trainId: this.$route.query.id,
                    userId: this.signInDialog.row.userId
                },
                pageData: this.signInForm.pageData
            }).then(res => {
                this.signInDialog.form.formResult = res.data
            })
        },
        // 学习管理-学员情况列表
        situationList() {
            this.$api.user.train.situationList({
                formData: {
                    orgId: this.situationSearchForm.orgId,
                    isGraduation: this.situationSearchForm.isGraduation,
                    userName: this.situationSearchForm.userName,
                    trainId: this.$route.query.id,
                },
                pageData: this.situationForm.pageData
            }).then(res => {
                this.situationForm.formResult = res.data
            })
        },
        queryStudentSignList() {

        },
        // 通知
        trainContentList() {
            this.$api.user.train.trainContentList({
                formData: {
                    trainId: this.$route.query.id,
                },
                pageData: this.contentForm.pageData
            }).then(res => {
                this.contentForm.formResult = res.data
            })
        },
        addContent() {
            this.contentDialog.visible = true
            this.contentDialog.form = {title: '', info: ''}
            this.$nextTick(() => {
                this.$refs.contentDialogForm.resetFields()
            })
        },
        handleContentDialogClose() {
            this.contentDialog.visible = false
        },
        handleContentDialogSave(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.contentDialog.form.id) {
                        this.$api.user.train.trainContentUpdate(this.contentDialog.form).then(res => {
                            this.trainContentList()
                            this.$message({message: '添加成功', type: 'success'})
                        })
                    } else {
                        this.$api.user.train.trainContentAdd({
                            info: this.contentDialog.form.info,
                            title: this.contentDialog.form.title,
                            trainId: this.$route.query.id,
                            userId: this.userInfo.id
                        }).then(res => {
                            this.contentForm.pageData.currentPage = 1
                            this.trainContentList()
                            this.$message({message: '添加成功', type: 'success'})
                        })
                    }
                    this.handleContentDialogClose()
                } else {
                    return false;
                }
            });
        },
        editContentItem(row) {
            this.contentDialog.visible = true
            this.$api.user.train.trainContentDetail({id: row.id}).then(res => {
                this.contentDialog.form = res.data
            })
            
            console.log(this.contentDialog.form)
        },
        deleteContentItem(row) {
            this.$confirm('确定删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.user.train.trainContentDelete({
                    list: [row.id]
                }).then(res => {
                    this.contentForm.pageData.currentPage = 1
                    this.trainContentList()
                    this.$message({message: '删除成功', type: 'success'})
                })
            }).catch(() => {})
        },
        // 实施部门
        getOrgTreeList() {
            this.$api.user.baseInfo.orgTreeList({name: '', orgManage: 1}).then(res => {
                this.orgList = res.data
            })
        },

        addMS() {

        },
        addKC() {

        },
        addKS() {

        },
        addZY() {

        },
        addDY() {

        },
        deleteItem(scope) {

        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.training-step4 {
    background: $white_bg_color;
    .training-btn-tab {
        display: flex;
        padding: .24rem .15rem 0;
        .training-btn-tab-item {
            width: .7rem;
            height: .25rem;
            border-radius: .03rem;
            line-height: .25rem;
            text-align: center;
            font-size: .12rem;
            color: $font_color_A6;
            cursor: pointer;
            & + .training-btn-tab-item {
                margin-left: .1rem;
            }
            &.active {
                color: $white_border_color;
                background: $bg_color_6D1;
            }
        }
    }
    .training-step4-line {
        margin: 0 .2rem;
        border-top: 1px solid $grey_border_color_e6;
    }
    .training-step4-btn-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .15rem;
        .title {
            font-size: .14rem;
            color: $font_color_51b;
        }
    }
    .training-step-right-btns {
        text-align: right;
        padding-right: .22rem;
        height: .3rem;
        .el-button--mini {
            vertical-align: top;
            width: .8rem;
            padding: .07rem .1rem;
        }
    }
    .training-step-table {
        padding: 0 .22rem 0 .1rem;
    }
    .training-step-btns {
        height: .83rem;
        padding: .24rem 0 .3rem;
        border-top: 1px solid $grey_border_color_e6;
        text-align: center;
        .el-button {
            vertical-align: top;
            width: .9rem;
        }
    }
    .act-detail-top {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: .2rem;
        .act-detail-top-item {
            width: 33.333%;
            line-height: .4rem;
        }
    }
}
</style>
<style lang="scss">
@import '../../../styles/variables.scss';
@import '../../../styles/mixin.scss';

.training-step4 {
    overflow: hidden;
    .el-tabs {
        margin-top: -.5rem;
    }
    .el-tabs__nav-wrap::after {
        height: 1px;
        background-color: $grey_border_color_e6;
    }

    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__item {
        font-size: .14rem;
        color: $font_color_A6;
        font-weight: 400;
    }
    
    .el-tabs__item.is-active {
        color: $font_color_51b;
    }

    .el-tabs__active-bar {
        height: 1px;
        background-color: $font_color_51b;
    }

    .el-tabs__item {
        padding: 0 .15rem;
    }

    .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
        padding-left: .3rem;
    }

    .training-search-form {
        padding: .25rem 0;
        @include clear-float();
        .el-form-item {
            float: left;
            height: .4rem;
            margin-left: .26rem;
            margin-right: 0;
            margin-bottom: 0;
            vertical-align: top;
            .el-form-item__label {
                vertical-align: top;
            }
            .reset-button {
                color: $font_color_A6;
            }
            &.search-btn-item {
                float: right;
                margin-right: .2rem;
            }
        }
        .el-input__inner {
            width: 2.4rem;
        }
    }

    .training-search-form-spec {
        padding-bottom: .1rem;
        .el-form-item {
           margin-left: .46rem;
           margin-bottom: .15rem;
        }
        .el-input__inner {
            width: 2.8rem;
        }
    }




    .training-step-table {
        .red {
            margin-right: .04rem;
            color: $font_color_F0;
        }
        .el-table {
            margin-bottom: .3rem;
            th {
                background: $grey_bg_color_f5;
                >.cell {
                    font-weight: 400;
                }
            }
            td, th {
                padding: .1rem 0;
            }
            thead {
                color: $font_color_4A;
            }
            td, th.is-leaf {
                border: 0;
            }
            &::before {
                height: 0;
            }
            
            .table-btn {
                display: inline-block;
                font-size: .13rem;
                cursor: pointer;
                &:hover {
                    opacity: .8;
                }
                i {
                    font-size: .16rem;
                    vertical-align: text-bottom;
                }
                >span {
                    margin-left: .04rem;
                }
            }
            .table-btn-delete {
                color: $font_color_2A;
            }
            .table-btn-view {
                color: $font_color_51b;
                margin-right: .3rem;
            }
            .table-act-name {
                width: 1.95rem;
            }
            .el-input__inner {
                height: .35rem;
                line-height: .35rem;
            }
            .el-date-editor.el-input, .el-date-editor.el-input__inner {
                width: 1.58rem;
            }
            .el-icon-time {
                display: none;
            }
            .el-input--prefix .el-input__inner {
                padding-left: .15rem;
            }
            .el-select {
                width: 100%;
            }
            .el-input__icon {
                line-height: .35rem;
            }
        }
    }

    .step-audit-dialog {
        .user-step-dialog-form {
            margin-top: .4rem;
            .el-input,.el-textarea,.el-date-editor {
                width: 4rem;
            }
            .el-form-item {
                margin-bottom: .15rem;
            }
            .el-textarea__inner {
                height: .8rem;
            }
            .step4-content-item {
                .el-textarea__inner {
                    height: 4rem;
                }
            }
        }
        .step-signup-form {
            padding-top: .4rem;
            .step-signup-form-item {
                margin-bottom: .36rem;
                font-size: .14rem;
                .title {
                    display: inline-block;
                    width: 2.1rem;
                    margin-right: .16rem;
                    text-align: right;
                    color: $font_color_08E;
                }
                .value {
                    display: inline-block;
                    color: $grey_font_color_80;
                }
            }
        }
        .step-signup-multi {
            padding: .4rem .24rem;
            font-size: .14rem;
            color: $font_color_08E;
        }
        .step-signup-num {
            padding: .24rem;
            color: $font_color_4A;
        }
        .dialog-footer {
            padding: .15rem .35rem;
            border-top: 1px solid $grey_border_color_e6;
            text-align: right;
            .el-button {
                width: .9rem;
                vertical-align: top;
            }
        }
        .training-step-table {
            padding: 0 .2rem;
        }
        .user-step-search-form {
            margin-top: .2rem;
            .el-input {
                width: 1.7rem;
            }
            .el-form-item {
                margin-bottom: .2rem;
            }
            .search-itrm-btn {
                margin-left: .2rem;
                .reset-btn {
                    color: $font_color_A6;
                }
            }
            .search-item-long-btn {
                margin-left: 3.36rem;
            }
        }
        .user-step-split-form {
            margin-top: .2rem;
            .el-form-item {
                margin-right: 0;
            }
            .form-left-item {
               .el-form-item__label {
                   width: 1.6rem;
               } 
            }
            .form-right-item {
               .el-form-item__label {
                   width: 1.5rem;
               } 
            }
            .el-input {
                width: 2.4rem;
            }
            .job-time-item.el-range-editor {
                width: 2.4rem;
            }
            .el-textarea {
                width: 6.17rem;
            }
        }
        .step-exam-border {
            padding: .2rem .2rem 0 .5rem;
        }
    }

    .step-signup-dialog {
        .dialog-footer {
            padding: .15rem .35rem;
            border-top: 1px solid $grey_border_color_e6;
            text-align: right;
            .el-button {
                width: .9rem;
                vertical-align: top;
                color: $font_color_F0;
            }
            .el-button--success {
                color: $white_border_color;
                background: $bg_color_200;
            }
        }
    }
}
</style>
